import React from 'react';
import { buildSafeGuardReason } from '../utils/safeGuardReason';

const ShieldIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M12 3.2l7 2.8v5.6c0 4.2-2.9 7.2-7 8.7-4.1-1.5-7-4.5-7-8.7V6l7-2.8z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
    <path d="M8.8 12.1l2.2 2.2 4.2-4.4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

/**
 * SafeGuardReasonBanner — sits in the reading pane of a parked mail and says
 * why SafeGuard held this contact. Renders nothing for ordinary mail.
 */
export default function SafeGuardReasonBanner({ email }) {
  const reason = buildSafeGuardReason(email);
  if (!reason) return null;

  return (
    <aside className="ivx-sg-reason" role="note" aria-label="Warum SafeGuard diese Mail gehalten hat">
      <div className="ivx-sg-reason-head">
        <span className="ivx-sg-reason-mark">
          <ShieldIcon />
        </span>
        <div className="ivx-sg-reason-titles">
          <span className="ivx-sg-reason-eyebrow">SafeGuard</span>
          <strong className="ivx-sg-reason-title">{reason.title}</strong>
        </div>
        {reason.pill && <span className="ivx-sg-reason-pill">{reason.pill}</span>}
      </div>
      {reason.body && <p className="ivx-sg-reason-body">{reason.body}</p>}
      {reason.points.length > 0 && (
        <ul className="ivx-sg-reason-points">
          {reason.points.map((point) => (
            <li key={point}>{point}</li>
          ))}
        </ul>
      )}
    </aside>
  );
}
